module.exports = __webpack_public_path__ + "img/vcard-icon.e6daa742.png";